module.exports = __webpack_public_path__ + "img/Postmodernisme_Bilde-fra-Tatt-av-kvinnen.a868ae9c.jpg";